import { render, staticRenderFns } from "./roleAdd.vue?vue&type=template&id=3f366bc9&scoped=true"
import script from "./roleAdd.vue?vue&type=script&lang=js"
export * from "./roleAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f366bc9",
  null
  
)

export default component.exports